import React from 'react';
import UnderHeader from '../../../shared/header/under-header';

import LicensesContent from './components/licenses-content';
import Head from '../../../shared/head';

const Licenses = () => {
    const heroImageContent = (
    <div id="hero-footer" className="hero-footer">
        <div className="row">
        <h1 className="brandon-light">Disclosures &amp; Licenses</h1>                        
        </div>
    </div>); 
    return(
        <>
            <Head title={`Loanpal ${window.location.pathname.split('/')[1]}`} />
            <UnderHeader                
                image="img-container-hero-footer-pages"                                
                bgColor="green-header"
                border=""
                heroImageContent={heroImageContent}
                showDIYSlideshow={false}
                showSlideshowMovie={false}
            />   
            <LicensesContent />                                
        </>                
    )
}

export default Licenses;